import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { UnsplashImage } from "./unsplash";
import { pixabayImageToUnsplashImageFormat } from "./image-bridge";
import { fetchWithJWT } from "@/futurelayer/auth/jwt";

export interface PixabayImage {
  id: number;
  pageURL: string;
  type: string;
  tags: string;
  previewURL: string;
  previewWidth: number;
  previewHeight: number;
  webformatURL: string;
  webformatWidth: number;
  webformatHeight: number;
  largeImageURL: string;
  imageWidth: number;
  imageHeight: number;
  imageSize: number;
  views: number;
  downloads: number;
  collections: number;
  likes: number;
  comments: number;
  user_id: number;
  user: string;
  userImageURL: string;
  fullHDURL?: string;
  imageURL?: string;
  vectorURL?: string;
  noAiTraining?: boolean;
  isAiGenerated?: boolean;
  isGRated?: boolean;
  isLowQuality?: boolean;
  userURL?: string;
}

export interface PixabaySearchResponse {
  total: number;
  totalHits: number;
  hits: PixabayImage[];
}

export interface PixabayRequest {
  query: string;
  page: number;
  per_page: number;
}

export async function callPixabay(
  request: PixabayRequest,
  abortController: AbortController
): Promise<UnsplashImage[]> {
  try {
    const response = await fetchWithJWT("/stock-photos/pixabay", {
      body: jsonStringifyOrUndefined(request),
      signal: abortController.signal
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result: PixabaySearchResponse = await response.json();
    return result.hits.map(pixabayImageToUnsplashImageFormat);
  } catch (error) {
    console.error("Pixabay request failed:", error);
    throw error;
  }
}